import { StrictMode, lazy, Suspense, useEffect } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Toaster } from 'sonner';
import './index.css';
import { AuthProvider, useAuth } from './auth/AuthContext';
import { LoginPage } from './auth/LoginPage';
import { AppShell } from './shell/AppShell';
import { Spinner } from './ui/Spinner';
import { ThemeProvider, useTheme } from './theme/ThemeProvider';

const qc = new QueryClient({
  defaultOptions: { queries: { retry: (n, e: any) => n < 1 && !(e?.status >= 400 && e?.status < 500), refetchOnWindowFocus: false, staleTime: 30_000 } },
});

const DesignGallery = lazy(() => import('./design/Gallery'));

function Root() {
  const { user, loading } = useAuth();
  const theme = useTheme();
  // oturum açılınca kullanıcının kayıtlı görünümü (yoksa şirket varsayılanı)
  useEffect(() => { if (user) theme.hydrate(user.tercih); }, [user]); // eslint-disable-line react-hooks/exhaustive-deps
  if (loading) return <Spinner />;
  return user ? <AppShell /> : <LoginPage />;
}

const isDesign = location.pathname === '/tasarim' || location.pathname.startsWith('/tasarim/');

createRoot(document.getElementById('root')!).render(isDesign ? (
  <StrictMode>
    <Suspense fallback={<Spinner />}><DesignGallery /></Suspense>
  </StrictMode>
) : (
  <StrictMode>
    <QueryClientProvider client={qc}>
      <ThemeProvider>
        <AuthProvider>
          <Root />
          <ThemedToaster />
        </AuthProvider>
      </ThemeProvider>
    </QueryClientProvider>
  </StrictMode>
));

function ThemedToaster() {
  const { dark } = useTheme();
  return <Toaster richColors position="bottom-right" closeButton theme={dark ? 'dark' : 'light'} />;
}
